import gql from 'graphql-tag';

export default gql`
  mutation adminEditOrganizationContacts($input: AdminEditOrganizationContactsInput!) {
    adminEditOrganizationContacts(input: $input) {
      id
    }
  }
`;
